import { useEffect, useState } from "react";
import { Header } from "../../common/header";
import { Footer } from "../main-page/footer";
import { Spinner } from "../../common/spinner";
import { useResetPasswordFirebaseLink } from "../../../services/firebase_email_actions";
import { PasswordInput } from "../../common/password-input";

export const AuthFBResetPassword = () => {
    const params = new URLSearchParams(window.location.search);
    const oobCode = params.get("oobCode");
    const [password, setPassword] = useState("");

    const { status, email, firebaseError, errorPassword, resetPassword, handleSavePassword } = useResetPasswordFirebaseLink();

    useEffect(() => {
        resetPassword(oobCode!);
    }, []);

    return (
        <>
            <Header title="Reset your password" />

            <div className="container py-5">
                <div className="row justify-content-center">
                    <div className="col-md-6 col-lg-5">
                        <div className="card shadow-sm border p-4 text-center rounded-4">
                            {status === "loadingFirebaseCustomPage" && (
                                <>
                                    <Spinner spinnerColor="text-primary" />
                                    <p className="text-muted">Validating reset link…</p>
                                </>
                            )}
                            {status === "working" && (
                                <>
                                    <Spinner spinnerColor="text-primary" />
                                </>
                            )}

                            {status === "error" && (
                                <>
                                    <i className="fa-solid fa-circle-exclamation text-primary fs-2 mb-2"></i>
                                    <p className="fw-bold text-primary">{firebaseError}</p>
                                </>
                            )}

                            {status === "firebasePageInitialized" && (
                                <>
                                    <h4 className="fw-bold mb-2 text-primary">Create a new password</h4>

                                    <p className="text-muted small mb-4">
                                        Reset password for <strong>{email}</strong>
                                    </p>

                                    <PasswordInput label="New password" value={password} onChange={setPassword} placeholder="Enter your new password" />

                                    {!!errorPassword && <p className="text-danger small">{errorPassword}</p>}

                                    <button
                                        className="btn btn-primary w-100 mt-3"
                                        onClick={() => {
                                            handleSavePassword(password, oobCode!);
                                        }}
                                    >
                                        Save new password
                                    </button>
                                </>
                            )}
                            {status === "done" && (
                                <>
                                    <i className="fa-solid fa-circle-check text-primary fs-2 mb-2"></i>
                                    <h5 className="fw-bold text-primary">Password updated successfully</h5>
                                    <p className="text-muted small mt-2">Redirecting you to home…</p>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </>
    );
};
